<template>
  <div class="page-content">

  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode'
export default {
  beforeRouteEnter (to, from, next) {
    next({ path: '/users' })
  },
  data () {
    return {
      user: {}
    }
  },
  methods: {
    async getUserDetails () {
      let token = localStorage.getItem('jwt')
      let decoded = VueJwtDecode.decode(token)
    },
    logUserOut () {
      localStorage.removeItem('jwt')
      this.$router.push('/')
    }
  },
  created () {
    this.getUserDetails()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue